import router from './router'
import propertyMessages from './localization'

export default {
  router,
  localization: propertyMessages,
}
